function arrayToObject(arr: { name: string; value: string }[]): Record<string, string> {
  return Object.fromEntries(arr.map(({ name, value }) => [name, value]));
}

export default arrayToObject;
